$(document).ready(function(){

  // home banner on slider
  const home_banner = new Swiper('.home_banner--section .home_banner--img .background_img .swiper',{
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 3000,
    },
  });
  
  $('.custom_banner--blocks .swiper').each(function(index){
    var $this = $(this);
    $this.addClass("custom_block_slider-" + index);
    const custom_block_row = new Swiper('.custom_block_slider-'+index,{
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.custom_block_slider-'+index+' .swiper-button-next',
        prevEl: '.custom_block_slider-'+index+' .swiper-button-prev',
      }
    });
  });

  //  Two row slider 
  const custom_two_row = new Swiper('.custom_two_row_slider .custom_two_row_slider_blocks .swiper', {
    autoHeight: true,
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      nextEl: '.custom_two_row_slider_blocks .swiper-button-next',
      prevEl: '.custom_two_row_slider_blocks .swiper-button-prev',
    }
  });

  //   const custom_two_row = new Swiper('.custom_two_row_slider .custom_two_row_slider_blocks .swiper', {
  //     slidesPerView: 2,
  //     spaceBetween: 20,
  //     grid: {
  //       rows: 2,
  //       fill:'row'
  //     },
  //     navigation: {
  //       nextEl: '.custom_two_row_slider_blocks .swiper-button-next',
  //       prevEl: '.custom_two_row_slider_blocks .swiper-button-prev',
  //     },
  //     breakpoints: {
  //       992:{
  //         slidesPerView: 4,
  //         spaceBetween: 36,
  //         grid: {
  //           rows: 2,
  //           fill:'row'
  //         },
  //       },
  //       750:{
  //         slidesPerView: 3,
  //         grid: {
  //           rows: 2,
  //           fill:'row'
  //         },
  //       }
  //     }
  //   });

  //   if(custom_two_row){
  //     if($(window).width() < 750){
  //       custom_two_row.destroy(true, true);
  //     }
  //     $(window).resize(function(){
  //       if($(window).width() < 750){
  //         custom_two_row.destroy(true, true);
  //       }
  //     });
  //   }

  //  Custom image with text slider
  
  $('.custom_img-with__txt .custom_img-with__txt_block-img .custom_img-with__txt--slider .swiper').each(function(index){
    var $this = $(this);
    $this.addClass("img_with-txt-slider-" + index);
    const custom_image_with_text_slider = new Swiper(".img_with-txt-slider-"+index, {
      slidesPerView: 'auto',
      loop: true,
      autoplay: {
        delay: 1500,
      },
    });
  });

  // //  megamenu position 
  // function megamenu_pos(){
  //   $('.header_item_has_submenu:not(.small_width) .mega-menu__content').css({left:'0px'});
  //   var pos_left = $('.header_item_has_submenu:not(.small_width)').offset().left;
  //   var body = $('#shopify-section-header').width();
  //   $('.header_item_has_submenu:not(.small_width) .mega-menu__content').css({left:'-'+pos_left+'px',width:body+'px'});
  // }
  // megamenu_pos();
  // $(window).resize(function(){
  //   megamenu_pos();
  // });


  //  video button click position
  $('.section_video_popup--blocks .video_btn').click(function(){
    $(this).siblings('.section_video_popup--wrap').fadeIn('500');
  });
  $('.section_video_popup--blocks .section_video_popup--wrap').click(function(){
    $(this).fadeOut('500');
    var src = $(this).parents('.custom_video_popup--blocks').find('iframe').attr('src')
    $(this).parents('.custom_video_popup--blocks').find('iframe').attr('src',src)
  });
  

  //  Size chart
  $("#size-chart__position .size-chart-custom_btn").on('click',function(){
    $("body").addClass("overflow-hidden");
    $(".size-chart_block-modal").fadeIn().addClass("size-chart_show");
  });

  $(".size-chart_block-modal .sizechart-close-btn,.size-chart_block-modal .size-chart_block-modal-overlay").on('click',function(){
    $(".size-chart_block-modal").fadeOut().removeClass("size-chart_show");
    $("body").removeClass("overflow-hidden");
  });
});